// ORIO brand assets
// Wordmark SVG used as CSS mask in headers/auth screens (paint with brand gradient on top)
export const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_dog-passport/artifacts/q97bbs31_svg%20loco%20scritta.svg";
// Symbol-only SVG (paw/heart pin shape) — for compact icons, splash, footer marks
export const LOGO_SYMBOL = "https://customer-assets.emergentagent.com/job_dog-passport/artifacts/uzvt8ys2_svg%20logo.svg";

// Map pins (still PNG)
export const LOGO_PIN_CENTER =
  "https://customer-assets.emergentagent.com/job_63d14371-4bff-450b-ab03-5e5e15af4832/artifacts/ld7z1csb_ZXZ.png";
export const LOGO_PIN_OFFSET =
  "https://customer-assets.emergentagent.com/job_63d14371-4bff-450b-ab03-5e5e15af4832/artifacts/y2055y93_XXZX.png";
